import { observer } from "mobx-react";
import * as React from "react";
import { IhistoryStateChangePassword } from "../../interface";
import { changePassword } from "../../actions/changePassword";
import { lang } from "../../lang";
import { store } from "../../store";
import { Button } from "../../components/atoms/Button";
import { CenteredContent } from "../../components/atoms/CenteredContent";
import { InputField } from "../../components/atoms/InputField";
import { Title } from "../../components/atoms/Text";
import { Template } from "../../components/organisms/Template";
import { catchEndpoint } from "../../catchEndpoint";
import { store as uiStore } from "../../store/ui";
import { logout } from "../../actions/logout";

@observer
class ProfilePage extends React.Component {
    public state = {
        newPsw: "",
        retypePsw: "",
        pswError: "",
        loading: false
    };
    public formChange = (value: string, name: string) => {
        const state = { ...this.state };
        state[name] = value;
        this.setState(state);
    };
    public formSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const historyState = window.history.state as Record<string, unknown> | undefined;
        const parameter = historyState ? (historyState.state as IhistoryStateChangePassword) : undefined;

        const { newPsw, retypePsw } = this.state;

        if (newPsw !== retypePsw) {
            this.setState({ pswError: lang.pswMismatch });
            return;
        } else if (!newPsw) {
            this.setState({ pswError: lang.invalidPsw });
            return;
        }

        this.setState({ loading: true });
        if (parameter && parameter.userId && !isNaN(parameter.userId as unknown as number)) {
            changePassword(parseInt(parameter.userId), newPsw)
                .then((result) => {
                    this.setState({ loading: false });

                    if (result) {
                        if (parseInt(parameter.userId) == uiStore.userid) {
                            store.doNotice(lang.pswChanged, true, 3000, () => {
                                logout();
                            });
                        } else {
                            store.doNotice(lang.pswChangedOnly, true);
                        }

                        this.setState({
                            newPsw: "",
                            retypePsw: "",
                            pswError: ""
                        });
                    }
                })
                .catch(catchEndpoint);
        } else {
            this.setState({ loading: false });

            store.doNotice(lang.userNotExist);
        }
    };

    public render(): React.ReactElement {
        const { pswError } = this.state;
        return (
            <Template>
                <CenteredContent>
                    <Title>{lang.changePsw}</Title>
                    <form onSubmit={this.formSubmit}>
                        <InputField
                            title={lang.newPsw}
                            name="newPsw"
                            type="password"
                            value={this.state.newPsw}
                            onChangeField={this.formChange}
                            data-at_id="input_new_password"
                        />
                        <InputField
                            title={lang.retypePsw}
                            name="retypePsw"
                            error={pswError}
                            type="password"
                            value={this.state.retypePsw}
                            onChangeField={this.formChange}
                            data-at_id="input_retype_password"
                        />
                        <Button
                            type="submit"
                            loading={this.state.loading}
                            disabled={this.state.loading}
                            right
                            title={lang.changePsw}
                            style={{ marginBottom: "-5px" }}
                            data-at_id="button_change_password"
                        />
                    </form>
                </CenteredContent>
            </Template>
        );
    }
}

export { ProfilePage };
